import { CssBaseline, IconButton } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import PageviewIcon from "@material-ui/icons/Pageview";
import MaterialTable from "material-table";
import { useHistory } from "react-router";
import LabelsContext from "../../../lang/LabelsContext";
import { getReviewStatus } from "../../../utils/Utils";
import CopyText from "../../system/copy-text/CopyText";
import { tableIcons } from "../../system/material-table-utils/MaterialTableUtils";
import AllManuscriptsService, { AllManuscriptsServiceType } from "./AllManuscriptsService";

export default function AllManuscripts() {
  const { Labels } = LabelsContext();

  const { articleList }: AllManuscriptsServiceType = AllManuscriptsService();

  const history = useHistory();

  return (
    <>
      <CssBaseline />
      <MaterialTable
        icons={tableIcons}
        columns={[
          {
            field: "articleId",
            title: Labels.ARTICLE_NUMBER,
            defaultSort: "desc",
            customSort: (a, b) => {
              let [aFirst, aSecond] = a.articleId.split("-");
              let [bFirst, bSecond] = b.articleId.split("-");
              aFirst = parseInt(aFirst);
              aSecond = parseInt(aSecond);
              bFirst = parseInt(bFirst);
              bSecond = parseInt(bSecond);

              if (aFirst === bFirst) {
                return aSecond - bSecond;
              }

              return aFirst - bFirst;
            },
          },
          {
            field: "articleTitle",
            title: Labels.TITLE,
            cellStyle: { width: "30%" },
            render: (rowData: any) => (
              <>
                <Link
                  component="button"
                  color="inherit"
                  align="left"
                  onClick={() => history.push(`/articleDetails/${rowData.id}`)}
                >
                  {rowData.articleTitle}
                </Link>
                <CopyText text={`#${rowData.articleId} ${rowData.articleTitle}`} />
              </>
            ),
          },
          {
            field: "status",
            title: Labels.STATUS,
            render: (rowData: any) => <div>{getReviewStatus(rowData.status, Labels)}</div>,
          },
          { field: "revision", title: Labels.REVISION_NUMBER },
          {
            title: Labels.VIEW,
            sorting: false,
            render: (rowData: any) => (
              <IconButton onClick={() => history.push(`/articleDetails/${rowData.id}`)}>
                <PageviewIcon fontSize="medium" />
              </IconButton>
            ),
          },
        ]}
        title={Labels.ALL_MANUSCRIPT}
        data={articleList}
        options={{
          actionsColumnIndex: -1,
          pageSize: 10,
          sorting: true,
          thirdSortClick: false,
        }}
      />
    </>
  );
}
